// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1csei","logo":"Header_logo__3xA9U","hamburger":"Header_hamburger__Qi5Bd","login":"Header_login__ClUGS"};